import React, { Component } from 'react';
import { Form, Input, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import { logIn, suLogIn } from 'actions/auth';
import { connect } from 'react-redux';

import './LoginPage.css';
import { resetTimer } from 'utils/timetracker';

const FormItem = Form.Item;

function mapState(state) {
  return {
    accessToken: state.auth.accessToken,
    suAccessToken: state.auth.suAccessToken
  };
}

function mapDispatch(dispatch) {
  return {
    logIn(data, superuser) {
      return superuser ? suLogIn(dispatch, data) : logIn(dispatch, data);
    }
  };
}

class LoginPage extends Component {
  state = {
    errors: ''
  };

  componentWillMount() {
    if (this.props.suAccessToken.length) {
      this.props.history.push('/psychics');
    } else if (this.props.accessToken.length) {
      this.props.history.push('/');
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { form, logIn, history } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        const superuser = ([
          'admin@mypsychic.com',
          'admin@psychics.com',
          'admin@psychicdb.com',
          'manager@mypsychic.com',
          'manager1@mypsychic.com',
          'managervox@psychicdb.com',

          'manager1@psychicdb.com',
          'manager2@psychicdb.com',
          'manager3@psychicdb.com',
          'manager4@psychicdb.com',
          'manager5@psychicdb.com',
          'manager6@psychicdb.com',
          'manager7@psychicdb.com',
          'manager8@psychicdb.com',
          'manager9@psychicdb.com',
          'manager10@psychicdb.com',
          'manager11@psychicdb.com',
          'manager12@psychicdb.com',
          'manager13@psychicdb.com',
          'manager14@psychicdb.com',
          'manager15@psychicdb.com',
          'manager16@psychicdb.com',
          'manager17@psychicdb.com',
          'manager18@psychicdb.com',
          'manager19@psychicdb.com',
          'manager20@psychicdb.com'
        ].includes(values.login));
        logIn(values, superuser)
          .then(() => {
            resetTimer();
            superuser ? history.push('/psychics') : history.push('/p-conversations');
          })
          .catch(e => {
            this.setState({ errors: e.message });
          });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="login-page layout horizontal center-center">
        <Form onSubmit={this.handleSubmit.bind(this)} className="login-form">
          <FormItem>
            {getFieldDecorator('login', {
              rules: [{ required: true, message: 'Please input your email!' }]
            })(
              <Input type="email" placeholder="email"/>
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }]
            })(
              <Input type="password" placeholder="password"/>
            )}
          </FormItem>
          <Button type="primary" htmlType="submit" className="full-width mb-10">Log in</Button>
          {this.state.errors && 'Incorrect email or password!'}
        </Form>
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(Form.create()(LoginPage)));



// WEBPACK FOOTER //
// ./src/pages/login/LoginPage.jsx